import { Component, OnInit } from '@angular/core';
import { AlertHandlerService } from '@finxone-platform/shared/services';
import { AlertTypes } from '@finxone-platform/shared/sys-config-types';

@Component({
  standalone: false,
  selector: 'finxone-workflow-frontend-alert-handler',
  templateUrl: './alert-handler.component.html',
  styleUrls: ['./alert-handler.component.scss'],
})
export class AlertHandlerComponent implements OnInit {
  public alertType = '';
  public alertMsg: string | undefined;
  public errorAlertMsgDiv: {
    background: string;
    border: string;
    color: string;
    'border-width': string;
  };
  public errorAlertErrorIconColor: { color: string };
  public errorAlertHeaderColor: { color: string; 'font-family': string };
  public errorCloseIconColor: { color: string };

  public successAlertMsgDiv: {
    background: string;
    border: string;
    color: string;
    'border-width': string;
  };
  public successAlertErrorIconColor: { color: string };
  public successAlertHeaderColor: { color: string; 'font-family': string };
  public successCloseIconColor: { color: string };
  public headerMsg: string | undefined;
  private defaultTimer = 4000;

  // Add warning alert variables
  public warningMsgDiv: {
    background: string;
    border: string;
    color: string;
    'border-width': string;
  };
  public warningAlertErrorIconColor: { color: string };
  public warningAlertHeaderColor: { color: string; 'font-family': string };
  public warningCloseIconColor: { color: string };

  constructor(private alertHandlerService: AlertHandlerService) {}
  ngOnInit() {
    const pc6 = '#FFFFFF';
    const ac0 = '#FF2323';
    const fFamily = 'Mulish';
    this.errorAlertMsgDiv = {
      background: pc6,
      border: 'solid ' + ac0,
      color: ac0,
      'border-width': ' 0 0 0 8px',
    };
    this.errorAlertErrorIconColor = { color: ac0 };
    this.errorAlertHeaderColor = { color: ac0, 'font-family': fFamily };
    this.errorCloseIconColor = { color: ac0 };

    const ac1 = '#1EA97C';
    this.successAlertMsgDiv = {
      background: pc6,
      border: 'solid ' + ac1,
      color: ac1,
      'border-width': ' 0 0 0 8px',
    };
    this.successAlertErrorIconColor = { color: ac1 };
    this.successAlertHeaderColor = { color: ac1, 'font-family': fFamily };
    this.successCloseIconColor = { color: ac1 };

    // Add warning alert style initialization
    const ac2 = '#ea8000'; // Example warning color
    this.warningMsgDiv = {
      background: pc6,
      border: 'solid ' + ac2,
      color: ac2,
      'border-width': ' 0 0 0 8px',
    };
    this.warningAlertErrorIconColor = { color: ac2 };
    this.warningAlertHeaderColor = { color: ac2, 'font-family': fFamily };
    this.warningCloseIconColor = { color: ac2 };

    this.alertHandlerService.showAlert$.subscribe((res) => {
      if (res?.length) {
        this.alertType = res[0].type as AlertTypes;
        this.alertMsg = res[0].msg;
        this.headerMsg = res[0].headerMsg;
        setTimeout(() => {
          this.alertHandlerService.hideAlert();
        }, this.defaultTimer);
      } else {
        this.alertType = '';
      }
    });
  }
}
